import interactiveElementSelector from '../interactiveElementSelector';

var isElementFocusable = function isElementFocusable(element) {
  var isVisible = !element.hidden;
  return isVisible && element.matches(interactiveElementSelector);
};

export default isElementFocusable;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/utils/dist/esm/isElementFocusable/index.js
// module id = 1043
// module chunks = 12